import type { Styles } from 'src/theme/themes';

export const styles = {
  treeItem: {
    '&& > .MuiTreeItem-content': {
      backgroundColor: 'transparent',
      alignItems: 'flex-start',

      '& > .MuiTreeItem-iconContainer': {
        paddingTop: 0.125,
        alignItems: 'flex-start',
      },

      '& > .MuiTreeItem-checkbox': {
        alignItems: 'flex-start',
      },

      '&:hover, &.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
        backgroundColor: `transparent`,
      },
    },
  },
} satisfies Styles;
